
function apply(html, scale, width, height) {
  const svgWidth = Math.round(width * scale);
  const svgHeight = Math.round(height * scale);
  const isDiv = html.tagName === 'DIV';
  if(isDiv) {
    html.style.height = `${svgHeight}px`;
    html.style.width = `${svgWidth}px`;
    const innerDiv = html.querySelector('.highcharts-container');
    innerDiv.style.height = `${svgHeight}px`;
    innerDiv.style.width = `${svgWidth}px`;
  }
  const svg = isDiv ? html.querySelectorAll('svg')[0] : html;
  const re = /\w+\([-|\d|,|\s]+\)/g;
  const svgChildren = svg.children;
  // Add a scale transform to all the svg's direct children.
  for (let i = 0; i < svgChildren.length; i++) {
    // Check if the element already has a transform set.
    const transform = svgChildren[i].getAttribute('transform');
    if (transform) {
      const transforms = transform.match(re);
      let hasScale = false;
      const isLegend = svgChildren[i].className.baseVal === 'highcharts-legend';
      const isDataLabels = svgChildren[i].classList[0] === 'highcharts-data-labels';
      const isAnnotationLabel = svgChildren[i].className.baseVal === 'highcharts-plot-line-label ';

      if(isLegend || isDataLabels || isAnnotationLabel) {
        const styles = svgChildren[i].getAttribute('style');
        if(styles){
          const stylesArr = styles.split(';');
          const newStyle = stylesArr.reduce((arr, style) => {
            if(!style.includes('transform')) return [...arr, style];
            return arr;
          }, [])
            .join(';');
          svgChildren[i].setAttribute('style', newStyle);
        }
      }
      for (let j = 0; !hasScale && transforms && j < transforms.length; j++) {
        // Overwrite the scale transform.
        if (transforms[j].indexOf('scale') === 0) {
          transforms[j] = `scale(${scale})`;
          hasScale = true;

        // Update the translate transform to account for scale.
        } else if (transforms[j].indexOf('translate') === 0) {
          const translateMatch = transforms[j].match(/(-?\d+),(-?\d+)/);
          transforms[j] = [
            'translate(',
            +translateMatch[1] * scale,
            ',',
            +translateMatch[2] * scale,
            ')'
          ].join('');
        } else if(transforms[j].indexOf('rotate') === 0){
          const rotateMatch = transforms[j].match(/(-?\d+) (-?\d+) (-?\d+)/);
          transforms[j] = [
            'rotate(',
            +rotateMatch[1],
            ' ',
            +rotateMatch[2] * scale,
            ' ',
            +rotateMatch[3] * scale,
            ')'
          ].join('');
        }
      }
      if (transforms) {
        if (!hasScale) {
          // Add scale to the transform if the transform does not
          // already have a scale property.
          transforms.push(`scale(${scale})`);
        }
        svgChildren[i].setAttribute('transform', transforms.join(' '));
      }
    } else {
      // No prior transform so write one just with a scale property.
      svgChildren[i].setAttribute('transform', `scale(${scale})`);
    }
  }

  // Double the size of the SVG.

  svg.setAttribute('width', svgWidth);
  svg.setAttribute('height', svgHeight);
  svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
  return html;
}

export default { apply };
